import { memoize } from '@/utils'

declare const VITE_CONFIG: RuntimeConfig

const fetchConfig = memoize(async (): Promise<string> => {
  try {
    const response = await fetch('/config.json', {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    })
    return await response.text()
  } catch (error) {
    console.error('Error loading config:', error)
  }

  return 'missing config'
})

const amplifyConfig = await fetchConfig()
const amplifyConfigJson = (await JSON.parse(amplifyConfig)) as AmplifyConfig
export const appConfig: AppConfig = {
  amplifyConfig: amplifyConfigJson,
  ...VITE_CONFIG,
  endpoint: amplifyConfigJson.restApi.endpoint,
}

/**
 * Get the endpoint for the given endpoint type
 * @param endpoint - The endpoint type to get the endpoint for
 * @returns The endpoint for the given endpoint type
 */
export function getEndpoint(
  endpoint: 'events' | 'entries' | 'user' | 'images' | 'invitations',
): string {
  return `${appConfig.amplifyConfig.restApi.endpoint}${endpoint}`
}

/**
 * @deprecated
 * Endpoint to interact with GuestbookEvents
 */
export const eventsEndpoint = getEndpoint('events')

/**
 * * @deprecated
 * Endpoint to interact with Entries
 */
export const entriesEndpoint = getEndpoint('entries')

/**
 * * @deprecated
 * Endpoint to interact with a user
 */
export const userEndpoint = getEndpoint('user')

/**
 * * @deprecated
 * Endpoint to interact with images
 */
export const imagesEndpoint = getEndpoint('images')
